var map = {
	"./1.jpg": "8554",
	"./2.jpg": "405a",
	"./3.jpg": "11d9",
	"./4.jpg": "bafb",
	"./Path 40.png": "125a",
	"./Path 41.png": "d5e8",
	"./Path 42.png": "f048",
	"./android.svg": "ac89",
	"./apple.png": "c32f",
	"./atm.png": "a33f",
	"./banner-natal.jpg": "1ec5",
	"./banner.jpg": "4c4a",
	"./banner2.jpg": "0d64",
	"./bg.jpg": "86d5",
	"./blog.png": "ee1c",
	"./camera.png": "c0b1",
	"./car.png": "c013",
	"./email.png": "9afb",
	"./fabrica.jpeg": "bb4a",
	"./facebook.png": "5307",
	"./facebook.svg": "aaa3",
	"./fechar-filtro.png": "f976",
	"./googleplay.png": "2c78",
	"./icones/bebe.png": "723a",
	"./icones/calcados.png": "9f6b",
	"./icones/diversos.png": "4b62",
	"./icones/estetica.png": "eb72",
	"./icones/evangelico.png": "170c",
	"./icones/feminino.png": "f753",
	"./icones/fitness.png": "4885",
	"./icones/impressao.png": "845f",
	"./icones/infantil.png": "86b1",
	"./icones/infnatil.png": "1e14",
	"./icones/intimo.png": "93a5",
	"./icones/jeans.png": "d898",
	"./icones/masculino.png": "79c4",
	"./icones/more.png": "4029",
	"./icones/perfumes.png": "97eb",
	"./icones/plus.png": "e6ab",
	"./icones/praia.png": "56c3",
	"./icones/restaurante.png": "4bfa",
	"./icones/shoes.png": "23f9",
	"./icones/sleep.png": "5a35",
	"./icones/zap-logo.png": "ca68",
	"./iconfb.png": "1246",
	"./iconinsta.png": "4037",
	"./insta.png": "1ddb",
	"./instagram.png": "c7f8",
	"./instagram.svg": "54e6",
	"./local-lojas.png": "5dbf",
	"./logo.png": "cf05",
	"./loterica.png": "762c",
	"./lupa.png": "6e00",
	"./menu-filtros.png": "a824",
	"./phone.png": "3547",
	"./pin.png": "56a2",
	"./printer.png": "9926",
	"./quadrados-link.png": "3dc4",
	"./seta-baixo.png": "db19",
	"./tailwind.css": "ba8c",
	"./vras.png": "f6dc",
	"./whats.png": "6028",
	"./wifi.png": "ec0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";